/* V2: Shopify owns prices/context. Recheck every return without a stale-state throttle. */
(() => {
  if (window.SNMarket) return;
  const node = document.getElementById('SNMarketContext');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const state = Object.freeze({ ...config, displayCurrency: config.currency, conversion: null });
  const key = [state.market, state.country, state.currency, state.language, state.root].join('|');
  let pending, timer, needsVerify = false, reloading = false;
  function paint() {
    document.querySelectorAll('[data-sn-current-currency]').forEach((el) => {
      if (el.textContent !== state.currency) el.textContent = state.currency;
    });
    document.querySelectorAll('[data-sn-current-language]').forEach((el) => {
      const label = state.language.toUpperCase();
      if (el.textContent !== label) el.textContent = label;
    });
  }
  async function verify() {
    paint();
    if (reloading) return false;
    if (window.Shopify?.designMode) return true;
    if (pending) return pending;
    clearTimeout(timer); timer = null; needsVerify = false;
    const url = new URL(location.href);
    ['sections', 'country', 'language'].forEach((name) => url.searchParams.delete(name));
    url.searchParams.set('section_id', 'sn-market-status');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    pending = fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sn-server-market]')?.dataset;
        if (!fresh?.country || !fresh.currency || !fresh.language) return;
        if (['country', 'currency', 'language', 'market'].some((name) => fresh[name] !== String(state[name] ?? ''))) {
          // Prices, availability and delivery rules move together. Never relabel stale prices.
          reloading = true;
          document.dispatchEvent(new CustomEvent('sn:market-invalidated', { detail: fresh }));
          location.reload();
        }
      }).catch(() => { /* The valid server-rendered page remains usable offline. */ })
      .finally(() => { clearTimeout(timeout); })
      .then(() => {
        pending = null;
        // A country change/return may happen while an older request is in flight.
        // All callers await this follow-up too; never reuse its stale result.
        if (needsVerify && !document.hidden && !reloading) return verify();
        return !reloading;
      });
    return pending;
  }
  function schedule() {
    paint();
    needsVerify = true;
    clearTimeout(timer);
    timer = setTimeout(() => { timer = null; verify(); }, 200);
  }
  function ready() {
    // Dynamic UI can flush a queued return check instead of using old cache keys.
    if (needsVerify || pending) return verify();
    return Promise.resolve(!reloading);
  }
  window.SNMarket = { state, config, key, refresh: verify, schedule, ready };
  paint();
  // No initial request: the current response includes authoritative context.
  window.addEventListener('pageshow', (event) => { paint(); if (event.persisted) verify(true); });
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule(); else clearTimeout(timer);
  });
  document.addEventListener('shopify:section:load', paint);
  document.addEventListener('sn:localization-selection', () => { needsVerify = true; verify(); });
})();
